// see: https://github.com/christo-pr/dangerously-set-html-content
import React, { HTMLAttributes, useEffect, useRef } from 'react'

interface Props extends HTMLAttributes<HTMLDivElement> {
  html: string;
}

export const DangerouslySetHtmlContent = (props: Props) => {
  const { html, ...rest } = props;
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (html && divRef?.current) {
      const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
      divRef.current.innerHTML = ''; // Clear the container
      divRef.current.appendChild(slotHtml); // Append the new content
    }
  }, [html])


  return <div {...rest} ref={divRef} />;
};
